"use strict";

let view_static = {
	namespace: 'static',
	beforeEnter: data => {
		// console.log("Home before enter", data);
	},
	afterEnter: () => {
		// console.log("Home after enter");
	}
}

export default view_static;